import {
  EmbeddedImage,
  EmbeddedSelectionContext,
} from "@intelligems/ig-types/schemas/plugin/plugin/embedded";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { selectElement } from "@src/store/slices/experienceBuilder/basicMod/thunks/selectElement";
import { openDialog } from "@src/store/slices/global";

export const selectElements = createAsyncThunk<void, EmbeddedSelectionContext>(
  "experienceBuilder/selectElements",
  async (context, { dispatch }) => {
    const { selected, images } = context;
    if (images.length > 1) {
      dispatch(
        openDialog({
          dialog: "multiImageSelect",
          props: {
            images,
            onSelect: (image: EmbeddedImage) => {
              void dispatch(selectElement({ node: image, nodes: selected }));
            },
          },
        })
      );
    } else {
      await dispatch(selectElement({ node: selected[0], nodes: selected }));
    }
  }
);
